<template>
  <div class="registrations">
      <h1 class="title">{{$t("registrations.registerTime")}}</h1>
      <div class="tabs">
        <ul>
            <router-link to="/reg" tag="li" v-bind:class="{'is-active': !$route.params.nav }" exact>
                <a>
                    {{$t("registrations.projectRegistration")}}
                </a>
            </router-link>
            <router-link to="/reg/week" tag="li" class="is-hidden-mobile" v-bind:class="{'is-active': navWeek }">
                <a>
                    {{$t("registrations.weekReg")}}
                </a>
            </router-link>
            <router-link to="/reg/month" tag="li" v-bind:class="{'is-active': navMonth }" exact>
                <a>
                    {{$t("registrations.monthReg")}}
                </a>
            </router-link>
            <router-link to="/reg/absence" tag="li" v-bind:class="{'is-active': navAbsence }">
                <a>
                    {{$t("registrations.absence")}}
                </a>
            </router-link>
        </ul>
      </div>
      <ProjectRegistrations v-if="!$route.params.nav" />
      <WeekRegistrations v-if="$route.params.nav === 'week'" />
      <MonthRegistrations v-if="$route.params.nav === 'month'" />
      <div v-if="$route.params.nav !== 'absence'" style="margin-top:1em">
        <a v-on:click="showAbsence = !showAbsence">
            <span class="icon">
                <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!showAbsence"></font-awesome-icon>
                <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="showAbsence"></font-awesome-icon>
            </span>
            {{$t("absence.showAbsence")}}
        </a>
        </div>
      <AbsenceRegistrations v-if="$route.params.nav === 'absence' || showAbsence" />
      <TimeStatus />
  </div>
</template>

<script>
import moment from 'moment'
import firebase from '@/firebase'

import ProjectRegistrations from '@/views/ProjectRegistrations.vue'
import WeekRegistrations from '@/views/WeekRegistrations.vue'
import MonthRegistrations from '@/views/MonthRegistrations.vue'
import AbsenceRegistrations from '@/views/AbsenceRegistrations.vue'
import TimeStatus from '@/components/status/TimeStatus.vue'

export default {
  name: 'registrations',
  components: {
      ProjectRegistrations,
      WeekRegistrations,
      AbsenceRegistrations,
      MonthRegistrations,
      TimeStatus
  },
   data: function() {
       return {
           showAbsence: false,
       }
   },
    firebase: function() { 
      const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
      return {
          orgSettings: {
              source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
              asObject: true,
              readyCallback() {
                  if(!this.$route.params.nav && this.orgSettings && this.orgSettings.standardRegistration && this.orgSettings.standardRegistration.type) {
                      this.$router.replace({
                        params: { nav: this.orgSettings.standardRegistration.type }
                    });
                  }
              }
          },
      }
    },
   computed: {
       navMonth() {
           if(this.$route.params.nav === 'month') {
               return true
           } else {
               return false
           }
       },
       navWeek() {
           if(this.$route.params.nav === 'week') {
               return true
           } else {
               return false
           }
       },
        navAbsence() {
           if(this.$route.params.nav === 'absence') {
               return true
           } else {
               return false
           }
       },
       weekBadge() {
           if(this.$route.params.time) {
               return this.$route.params.time
           } else {
                moment.locale(this.$i18n.locale)
                return moment().isoWeek();
           }
       }
   }
}
</script>
<style scoped>
    .has-margin {
        margin-left: 0.5em;
    }
</style>

